<template>
    <fragment>
        <InsideHeader :title="pageData.title" :bredcrumb="breadcrumb" />
        <section id="contact" class="contact-area contact-page-area">
            <div class="container">
                <div class="row contact-page-address-wrap">
                    <div class="col-12 col-lg-4 col-md-4" v-if="$store.state.site.siteAddress">
                        <div class="contact_us_box wow fadeInLeft" data-wow-duration="1.0s" data-wow-delay=".4s">
                            <h4>Address</h4>
                            <p v-html="$store.state.site.siteAddress"></p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4 col-md-4" v-if="$store.state.site.sitePhone">
                        <div class="contact_us_box wow fadeInUp" data-wow-duration="1.0s" data-wow-delay=".4s">
                            <h4>Phone</h4>
                            <ul class="contact_us_box_list">
                                <li><a :href="`tel:${$store.state.site.sitePhone}`"><i class="fas fa-phone-alt"></i> {{ $store.state.site.sitePhone }}</a></li>
                                <li v-if="$store.state.site.sitePhone !== null">Help: <a :href="`tel:${$store.state.site.sitePhone}`"> {{ $store.state.site.sitePhone }}</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4 col-md-4" v-if="$store.state.site.siteEmail">
                        <div class="contact_us_box wow fadeInRight" data-wow-duration="1.0s" data-wow-delay=".4s">
                            <h4>Email</h4>
                            <ul class="contact_us_box_list">
                                <li><a :href="`mailto:${$store.state.site.siteEmail}`"><i class="fas fa-envelope"></i> {{ $store.state.site.siteEmail }}</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center">

                    <div class="col-12 col-sm-12 col-md-3 col-lg-5">
                        <div class="support-forum-img-box">
                            <img src="../../public/img/contact-page-left.svg" alt="support">
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-9 col-lg-7">
                        <div class="contact-form-wrapper">
                            <div class="section-title-area text-left"><h2 class="section-heading">Tell Us! <span class="d-block"></span></h2></div>
                            <ContactForm/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </fragment>
</template>

<script>
import InsideHeader from "../components/InsideHeader.vue";
import ContactForm from "../components/Contact/Form";

export default {
    components: {
        InsideHeader, 
        ContactForm
    },
    data(){
        return {
            breadcrumb: [
                {title: 'Home', path:'/'},
                {title: 'Contact Us', path:'#'}
            ],
            filePath: '',
            pageData: {}
        }
    },
    methods: {
        getData(){            
            this.$http.get(`/contact-us`).then(res=>{                       
                if(res.status === 200 && res.data){
                    if(res.data.page_data)
                        this.pageData = res.data.page_data
                    if(res.data.file_path)
                        this.filePath = res.data.file_path
                }
            })
        }
    },
    created: function(){
        this.getData()
    }
}
</script>